function CopyNotif(props){
    return(
        <div className={'copy-notification' + (props.active ? ' active' : '')}>
            <span>کپی شد!</span>
        </div>
    )
}

export default CopyNotif